export default "__VITE_ASSET__CTDLKe5n__"